<template>
    <adaptive-modal :name="name" :hide-action-buttons="true">
        <div class="flex flex-col">
            <div class="mb-2xl">
                <h1 class="m-0 text-md">
                    Registerutdrag för {{ customer.name }}
                </h1>
            </div>

            <div class="text-left w-full">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Ladda ned</th>
                            <th>Status</th>
                            <th>Skapad</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="w-1/2">
                                <a v-if="hasMedia" :href="downloadRoute">
                                    <font-awesome-icon icon="download" />
                                    Ladda ned registerutdrag
                                </a>
                                <span v-else>
                                    -
                                </span>
                            </td>
                            <td>
                                <span :class="`text-${statusIconColor}`">
                                    {{ statusLabel }}
                                </span>
                            </td>
                            <td>
                                {{ createdAt }}
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="customerExcerpt.message" class="m-md">
                    <h1 class="text-md">
                        Meddelande:
                    </h1>
                    {{ customerExcerpt.message }}
                </div>
            </div>
            <div class="mt-2xl">
                <button
                    type="button"
                    class="btn is-ghost btn-lg"
                    @click="$modal.hide(name)"
                >
                    Stäng
                </button>
            </div>
        </div>
    </adaptive-modal>
</template>
<script>
    import { format } from 'date-fns';

    export default {
        props: {
            name: {
                type: String,
                required: true,
            },
            customerExcerpt: {
                type: Object,
                required: true,
            },
            customer: {
                type: Object,
                required: true,
            },
            hasMedia: {
                type: Boolean,
                required: true,
            },
            statusIconColor: {
                type: String,
                required: true,
            },
            statusLabel: {
                type: String,
                required: true,
            },
        },

        computed: {
            createdAt() {
                return format(
                    this.customerExcerpt.created_at,
                    'YYYY-MM-DD HH:mm',
                );
            },

            downloadRoute() {
                return route('admin.gdpr.customer-excerpts.download', this.customerExcerpt);
            },
        },
    };
</script>
